/* eslint-disable indent */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import { Form, Col, Row, Input, Radio, message } from "antd";
import { checkSpecialCharacter } from "../../../utils";
import { checkSpace } from "../../../utils";
import axios from "axios";
import "../../../commonStyles/global.css";
import "../../../commonStyles/stepButton.css";
import "../style.scss";
const Dox = ({
  descriptionValue,
  valueInput,
  details,
  parseInt,
  setChargeError,
  chargeError,
  senderGstNubmer,
  checkNumbervalue,
  gst,
  activeListData,
  screen,
  transporterId,
  todayTime,
  eWayBillHandle = () => {},
  onFreightChange = () => {},
  onCESSChange = () => {},
  inptHandler = () => {},
}) => {
  let localData = JSON.parse(localStorage.getItem("details"));
  const [radioValue, setRadioValue] = useState("no");
  const [eWayStatus, setEwayStatus] = useState(false);
  const onRadioChange = (e) => {
    setRadioValue(e.target.value);
  };

  useEffect(() => {
    if (valueInput >= 50000 && radioValue === "no") {
      setEwayStatus(true);
    } else {
      setEwayStatus(false);
    }
  }, [screen, radioValue]);
  return (
    <>
      <h4>Service Details</h4>
      <Row justify="center" gutter={32}>
        <Col xs={8}>
          <Form.Item
            name="type"
            label="Type"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="service"
            label="Service"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="travelBy"
            label="Travel by"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="center" gutter={32}>
        <Col span={8}>
          <Form.Item name="content" label="Content">
            <Input disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="descriptions"
            label="Description"
            value={descriptionValue}
          >
            <Input disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="value"
            label="Value (INR)"
            rules={[
              {
                required: true,
                message: "Please enter shipment value",
              },
            ]}
          >
            <Input min={0} type="number" disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="center" gutter={32}>
        <Col span={8}>
          <Form.Item
            name="Weight"
            defaultValue={"sdsdsdd"}
            label="Weight (Gms)"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input min={1} type="number" disabled value={"assdsaas"} />
          </Form.Item>
        </Col>
        {valueInput >= 50000 ? (
          <Col span={8} _ className="sez">
            <Form.Item name="sez" label="Is SEZ?">
              <Radio.Group onChange={onRadioChange} defaultValue={radioValue}>
                <Radio value={"yes"}>Yes</Radio>
                <Radio value={"no"}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        ) : null}
        <Col span={8}>
          <Form.Item
            name="eWayBill"
            label={<p className="eway-bill">E-Way Bill No</p>}
            rules={[
              {
                required: eWayStatus,
                message: "Enter E-Way number",
              },
              () => ({
                async validator(_, value) {
                  // console.log(value, "value");
                  if (value === undefined || value.length === 0) {
                    return Promise.resolve();
                  } else if (value.length === 12) {
                    try {
                      let data = await axios.get(
                        `https://api.mastergst.com/ewaybillapi/v1.03/ewayapi/getewaybill?email=pravat@hutechsolutions.com&ewbNo=${value}`,
                        {
                          headers: {
                            ip_address: "192.168.0.126",
                            client_id: "7527f4c8-dcb3-4394-8386-e29cde76aaf9",
                            client_secret:
                              "355c8f28-71f1-43cf-b26e-43558e1e23c1",
                            gstin: "05AAACH6188F1ZM",
                          },
                        }
                      );
                      const dateOne = new Date(
                        data?.data?.data?.validUpto
                          ?.split(" ")[0]
                          ?.split("/")
                          ?.reverse()
                          ?.join("/")
                          ?.replaceAll("/", ", ")
                      );
                      const dateTwo = new Date(
                        todayTime
                          ?.split(" ")[0]
                          ?.split("/")
                          ?.reverse()
                          ?.join("/")
                          ?.replaceAll("/", ", ")
                      );
                      if (data?.data?.status_cd === "0") {
                        return Promise.reject("Network error");
                      } else if (dateTwo > dateOne) {
                        // console.log("hiii");
                        return Promise.reject("E-Way-bill expired");
                      } else if (
                        data?.data?.data?.transporterId !== transporterId
                      ) {
                        return Promise.reject("Transporter id is not matching");
                      } else {
                        return Promise.resolve(
                          message.success("E-Way bill request succeeds")
                        );
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  } else if (value.length < 12) {
                    return Promise.reject("Give a valid E-Way bill no.");
                  }
                },
                // validateTrigger: "On",
              }),
            ]}
            onKeyPress={(event) => {
              if (checkSpecialCharacter(event)) {
                event.preventDefault();
              }
            }}
          >
            <Input
              defaultValue={""}
              maxLength={12}
              placeholder="Enter here"
              onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
              onKeyPress={(e) => {
                if (/[^0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={eWayBillHandle}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="senderGst"
            label="Sender’s GST number"
            onChange={inptHandler}
            onKeyPress={(event) => {
              if (checkSpecialCharacter(event)) {
                event.preventDefault();
              }
            }}
            rules={[
              {
                message: null,
                validateTrigger: "onSubmit",
              },
              () => ({
                validator(_, value) {
                  if (
                    value.length === 15 &&
                    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
                      value
                    ) === false
                  ) {
                    return Promise.reject({
                      max: 15,
                      min: 15,
                      message: "Please enter a valid GST Number",
                    });
                  } else if (activeListData.data.includes(value)) {
                    return Promise.reject({
                      message:
                        "GST belongs to a CP. Please enter another GST number.",
                    });
                  } else if (value.length > 0 && value.length < 15) {
                    return Promise.reject({
                      message: "Please enter a valid GST Number",
                    });
                  }
                  return Promise.resolve({});
                },
                validateTrigger: "onSubmit",
              }),
            ]}
          >
            <Input
              maxLength={15}
              minLength={15}
              placeholder="Enter GST number"
              onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
              onKeyPress={(event) => {
                if (checkSpecialCharacter(event) || checkSpace(event)) {
                  event.preventDefault();
                }
              }}
              value={details.senderGst}
            />
          </Form.Item>
        </Col>
      </Row>
      <h4>Charges Details</h4>
      <Row justify="center" gutter={32}>
        <Col span={8}>
          <Form.Item
            name="charges"
            label="Charges (INR)"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder="35" type="number" disabled />
          </Form.Item>
        </Col>
        {!gst || senderGstNubmer.length === 0 || senderGstNubmer === null ? (
          <Col span={8}>
            <Form.Item name="igst" label="IGST@18%">
              <Input placeholder="3.15" disabled />
            </Form.Item>
          </Col>
        ) : (
          <>
            <Col span={8}>
              <Form.Item
                name="sgst"
                label="SGST@9%"
                onKeyPress={(event) => {
                  if (
                    checkNumbervalue(event) ||
                    checkSpecialCharacter(event) ||
                    checkSpace(event)
                  ) {
                    event.preventDefault();
                  }
                }}
              >
                <Input placeholder="3.15" disabled type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="cgst"
                label="CGST@9%"
                onKeyPress={(event) => {
                  if (
                    checkNumbervalue(event) ||
                    checkSpecialCharacter(event) ||
                    checkSpace(event)
                  ) {
                    event.preventDefault();
                  }
                }}
              >
                <Input placeholder="3.15" disabled />
              </Form.Item>
            </Col>
          </>
        )}
        <Col span={8}>
          <Form.Item
            name="cess"
            label="CESS (INR)"
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
            onChange={onCESSChange}
          >
            <Input placeholder="00" min={0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="freight"
            label="Freight"
            rules={[
              {
                message: null,
              },
            ]}
            onChange={(e) => {
              let err =
                parseInt(e.target.value) >=
                parseInt(
                  parseInt(
                    localData?.selectedMode?.estimatedPriceWithId
                      ?.estimatedPrice
                  )
                );
              if (err) {
                onFreightChange(e);
                setChargeError(false);
              } else {
                setChargeError(true);
              }
            }}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
          >
            <Input value={details?.freight} disabled />
          </Form.Item>
          <p
            style={{
              color: "red",
              textAlign: "justify",
              marginBottom: "8px",
              marginTop: "-14px",
            }}
          >
            {chargeError ? "Freight cannot be less than calculated value" : ""}
          </p>
        </Col>
      </Row>
    </>
  );
};
export default Dox;
